<template>
    <div>
        <PaymentHeader :step="step" />

        <main id="content" class="payment-content">
            <div class="container">
                <CartServiceOptions v-if="step === 'step1'" />
                <PaymentMethod v-if="step === 'step2'" />
                <PaymentNotification v-if="step === 'step3'" />
            </div>
        </main>
        <LandingValues />
    </div>
</template>

<script>
import PaymentHeader from "@/components/cart/PaymentHeader";
import CartServiceOptions from "@/components/cart/CartServiceOptions";
import PaymentMethod from "@/components/cart/PaymentMethod";
import PaymentNotification from "@/components/cart/PaymentNotification";
import LandingValues from "@/components/LandingValues";
import { mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "Cart",
    components: {
        PaymentHeader,
        LandingValues,
        CartServiceOptions,
        PaymentMethod,
        PaymentNotification
    },
    mounted() {
        setDescriptionPage(get(this.general, "cart_page_metades"));
    },
    computed: {
        ...mapState({
            step: state => get(state, "cart.step", "step1"),
            general: state => get(state, "app.general", {})
        })
    }
};
</script>
